import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useContact } from "../hooks";

type IContactParams = {
  id: string;
};

export const Contact: React.FC = () => {
  const { id } = useParams<IContactParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useContact(+id!);

  if (loading) return <Loading />;

  const contact = data?.contact?.result;

  return (
    <>
      <Header
        title="Contact"
        subtitle={`${contact?.firstname ?? ""} ${contact?.lastname ?? ""}`}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/contact/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Prénom</p>
                    <input className="input w-full" value={contact?.firstname} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Nom</p>
                    <input className="input w-full" value={contact?.lastname ?? ""} disabled />
                  </div>
                </div>
              </div>
              <div className="w-full mt-3">
                <p className="label">Téléphone</p>
                <input className="input w-full" value={contact?.phone} disabled />
              </div>
              <div className="w-full mt-3">
                <p className="label">Client</p>
                <input className="input w-full" value={contact?.customer?.name ?? ""} disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
